<template lang="pug">
v-app
  slot
</template>

<script>
export default {
  data() {
    return {
      theme: 'light',
    };
  },

  watch:{
    theme:{
      handler(v) {
        this.$vuetify.theme.dark = v;
        localStorage.setItem('theme', this.theme  ?  'dark' : 'light');
      },
    },
  },
  created() {
    const value = localStorage.getItem('theme');
    this.theme = value === 'dark';
  },
};

</script>

<style>

</style>
